/** The two print boxes, in the units the canvas states them and in PDF points. Shared with `tools/proofs`. */

/** Millimeters, as the canvas states them. */
export const BADGE_MM = { width: 60, height: 86 } as const;
export const LETTER_IN = { width: 8.5, height: 11 } as const;
/** PDF points per inch; a millimeter is 72 / 25.4 points. */
export const PT_PER_IN = 72;
export const PT_PER_MM = 72 / 25.4;

export const BADGE_PT = {
  width: BADGE_MM.width * PT_PER_MM,
  height: BADGE_MM.height * PT_PER_MM,
} as const;
export const LETTER_PT = {
  width: LETTER_IN.width * PT_PER_IN,
  height: LETTER_IN.height * PT_PER_IN,
} as const;

export type PrintKind = 'badge' | 'letter';
